/**
 * useUnsavedChangesDialog - Business logic for unsaved changes warning dialog
 */
import { useTranslate } from 'core/hooks/useTranslate';

type UseUnsavedChangesDialogReturn = {
  t: (key: string) => string;
  title: string;
  warningText: string;
  discardButtonText: string;
  saveButtonText: string;
  cancelButtonText: string;
};

function useUnsavedChangesDialog(): UseUnsavedChangesDialogReturn {
  const { t } = useTranslate();

  return {
    t,
    title: t('organize-content:Unsaved changes'),
    warningText: t('organize-content:Unsaved changes warning'),
    discardButtonText: t('organize-content:Discard and close'),
    saveButtonText: t('organize-content:Save and close'),
    cancelButtonText: t('actions:Cancel'),
  };
}

export default useUnsavedChangesDialog;
